(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSimilarJobs', sodSimilarJobs);

    function sodSimilarJobs() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-similar-jobs',
            controller: sodSimilarJobsCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodSimilarJobsCtrl($scope, lodash, GenericModel) {
            var vm = this;

            // functions
            this.$onInit = function() {
                // initializations
                vm.isLoading = false;
                vm.similarJobs = [];
                init();
            }


            function getSimilarJobs() {
                if (vm.isLoading) return;

                var datasource = lodash.get(vm, 'config.datasource', {});
                var datasourceURL = lodash.get(datasource, 'url', null);
                var datasourceMethod = lodash.get(datasource, 'method', null);

                var model = new GenericModel(datasourceURL);
                model[datasourceMethod]({}).$promise.then(function (res) {
                    vm.similarJobs = lodash.get(res, 'rows', []);
                    vm.isLoading = false;
                }, function (error) {
                    console.log('error', error);
                    vm.isLoading = false;
                });
            }

            function init() {
                getSimilarJobs();
            }
        }
    }
})();